import { AwardSeasonLandingPage } from "@features/awards/components/AwardSeasonLandingPage"
import { defineView } from "eddev/views"

export const meta: ViewMeta = {
  templateName: "Awards Home",
}

export default defineView("template-awards-home", (props) => {
  return <AwardSeasonLandingPage award={props.latestAward!} />
})
